import React from 'react';
import { motion } from 'framer-motion';

export const EASE = [0.22, 1, 0.36, 1];

const OFFSETS = {
  up: { y: 50 }, down: { y: -40 }, left: { x: -60 }, right: { x: 60 },
  zoom: { scale: 0.88 }, none: {}, blur: { y: 24, filter: 'blur(12px)' },
  flip: { rotateX: -35, y: 40, transformPerspective: 900 },
};

/* Fades + moves children into view once when scrolled to */
export function Reveal({ children, from = 'up', delay = 0, duration = 0.9, className, style, as = 'div', amount = 0.25, ...rest }) {
  const M = motion[as] || motion.div;
  const hidden = { opacity: 0, ...OFFSETS[from] };
  const shown = { opacity: 1, x: 0, y: 0, scale: 1, rotateX: 0, filter: 'blur(0px)' };
  return (
    <M className={className} style={style} initial={hidden} whileInView={shown}
      viewport={{ once: true, amount }} transition={{ duration, delay, ease: EASE }} {...rest}>
      {children}
    </M>
  );
}

/* Parent that staggers its <StaggerItem> children */
export function Stagger({ children, className, style, gap = 0.08, delay = 0, amount = 0.15, as = 'div' }) {
  const M = motion[as] || motion.div;
  return (
    <M className={className} style={style} initial="hidden" whileInView="show" viewport={{ once: true, amount }}
      variants={{ hidden: {}, show: { transition: { staggerChildren: gap, delayChildren: delay } } }}>
      {children}
    </M>
  );
}

export const itemVariants = {
  hidden: { opacity: 0, y: 46, scale: 0.97 },
  show: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.85, ease: EASE } },
};

export function StaggerItem({ children, className, style, as = 'div', ...rest }) {
  const M = motion[as] || motion.div;
  return <M className={className} style={style} variants={itemVariants} {...rest}>{children}</M>;
}
